<div class="svg-container">
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 906 355.3"
    style="enable-background: new 0 0 906 355.3"
    xml:space="preserve"
  >
    <path
      class="st0"
      d="M870.8,0.2C857.4,1.4,533,20.9,505.6,22.6c-16.6,1-29.6,14.8-29.5,31.5c0,66.1,0,121.1,0.1,187.3
	c0.1,3.2,0.6,6.5,1.5,9.6c3,10.7,14,22.6,32.6,22.5c15-0.1,37.7-0.1,64-0.1v81.9l82-82c61.1,0,128.3,0,152.1,0
	c17.5,0,30.3-8.7,35.2-25.5c6.9-23.9,46.8-156.9,61.1-205.2C911.7,18.2,892.6-1.9,870.8,0.2"
    />
    <path
      class="st1"
      d="M90.6,235.7c5.8,0,11.6-0.3,17.3-1c4.9-0.6,9.8-1.6,14.6-2.9c4.4-1.3,8.6-2.8,12.8-4.8c4.1-1.9,8.1-4,12.2-6.3
	V171h-35.5c-0.9,0-1.8-0.3-2.4-0.9c-0.6-0.5-1-1.3-1-2.1v-7.3h51v65.6c-4.6,3.2-9.4,6.1-14.4,8.6c-5.1,2.6-10.4,4.7-15.9,6.4
	c-6,1.8-12.1,3.1-18.3,3.9c-7.1,1-14.2,1.4-21.4,1.4c-12.5,0.2-24.9-2.1-36.5-6.7c-10.7-4.3-20.3-10.8-28.3-19.1
	c-8.1-8.6-14.3-18.7-18.3-29.8C2.2,179.3,0,166.4,0,152.1c0-14.3,2.2-27.2,6.6-38.8c4-11.1,10.3-21.2,18.5-29.8
	c8.2-8.4,18.2-14.8,29.2-19c11.4-4.5,24.2-6.7,38.4-6.7c6.5,0,13,0.4,19.5,1.4c5.7,0.9,11.2,2.3,16.6,4.2c5,1.8,9.8,4.1,14.4,6.9
	c4.5,2.8,8.8,6,12.8,9.5l-3.5,5.7c-0.6,1.2-1.9,2-3.3,2c-0.8,0-1.5-0.2-2.2-0.5c-2-1-3.9-2.3-5.7-3.8c-3.2-2.3-6.5-4.3-10.1-6
	c-5.1-2.4-10.4-4.3-15.8-5.6c-7.6-1.8-15.3-2.6-23.1-2.4c-11.1-0.2-22.1,1.8-32.5,5.7C50.4,78.7,42,84.2,35,91.4
	c-7.1,7.5-12.4,16.4-15.8,26.1c-3.7,10.3-5.6,21.8-5.6,34.6c0,13,1.9,24.7,5.6,35.1c3.4,9.8,8.7,18.7,15.7,26.3
	c6.8,7.2,15.1,12.8,24.3,16.5C69.3,233.9,79.9,235.9,90.6,235.7"
    />
    <path
      class="st1"
      d="M272.7,244.5c-2.3,0.2-4.4-1.4-4.8-3.6l-1.8-16.6c-3.4,3.3-6.9,6.4-10.6,9.4c-3.4,2.7-7.1,5.1-11,7
	c-3.9,2-8.1,3.4-12.4,4.4c-4.8,1-9.7,1.5-14.6,1.5c-4.4,0-8.7-0.7-12.9-2c-4.1-1.2-7.8-3.3-11.1-6c-3.3-2.8-6-6.3-7.8-10.3
	c-2.1-4.8-3.1-10-2.9-15.2c0-5.4,1.6-10.8,4.7-15.3c3.1-4.7,8-8.8,14.7-12.3s15.2-6.3,25.7-8.4c10.5-2.1,23.1-3.3,37.8-3.6v-13.6
	c0-12-2.6-21.2-7.8-27.7c-5.2-6.5-12.8-9.7-23-9.7c-5.4-0.1-10.9,0.7-16,2.6c-3.9,1.5-7.7,3.4-11.1,5.7c-2.6,1.7-5.1,3.7-7.4,5.8
	c-1.9,1.7-3.5,2.6-4.8,2.6c-1.7,0.1-3.2-0.9-3.9-2.4l-2.2-3.8c6.2-6.3,13.4-11.6,21.4-15.4c8-3.6,16.7-5.4,25.4-5.2
	c6.2-0.1,12.5,1,18.2,3.3c5,2.1,9.5,5.3,13,9.5c3.6,4.4,6.2,9.5,7.8,15c1.8,6.4,2.6,13,2.5,19.6v84.5H272.7z M220.5,237.6
	c4.7,0.1,9.3-0.5,13.9-1.6c4.1-1,8-2.6,11.8-4.6c3.6-2,7-4.3,10.1-7c3.1-2.7,6.2-5.6,9.3-8.7v-33.8c-10.7,0.2-21.3,1.1-31.9,2.8
	c-8.9,1.5-16.2,3.6-22,6.2c-5.8,2.6-10,5.7-12.8,9.3c-2.7,3.5-4.2,7.9-4.1,12.3c-0.1,3.9,0.6,7.7,2.2,11.3c1.3,3,3.2,5.7,5.7,7.8
	c2.4,2.1,5.2,3.6,8.2,4.5C213.9,237.1,217.2,237.6,220.5,237.6"
    />
    <rect x="310" y="54.7" class="st1" width="12.4" height="189.8" />
    <path
      class="st1"
      d="M440.7,244.5c-2.3,0.2-4.4-1.4-4.8-3.6l-1.8-16.6c-3.4,3.3-6.9,6.4-10.6,9.4c-3.4,2.7-7.1,5.1-11,7
	c-3.9,2-8.1,3.4-12.4,4.4c-4.8,1-9.7,1.5-14.6,1.5c-4.4,0-8.7-0.7-12.9-2c-4.1-1.2-7.8-3.3-11.1-6c-3.3-2.8-6-6.3-7.8-10.3
	c-2.1-4.8-3.1-10-2.9-15.2c0-5.4,1.6-10.8,4.7-15.3c3.1-4.7,8-8.8,14.7-12.3c6.7-3.5,15.2-6.3,25.7-8.4c12.5-2.3,25.1-3.5,37.8-3.6
	v-13.6c0-12-2.6-21.2-7.8-27.7s-12.8-9.7-23-9.7c-5.4-0.1-10.9,0.7-16,2.6c-3.9,1.5-7.7,3.4-11.1,5.7c-2.6,1.7-5.1,3.7-7.4,5.8
	c-1.9,1.7-3.5,2.6-4.8,2.6c-1.7,0.1-3.2-0.9-3.9-2.4l-2.2-3.8c6.2-6.3,13.4-11.6,21.4-15.4c8-3.6,16.7-5.4,25.4-5.2
	c6.2-0.1,12.5,1,18.3,3.3c5,2.1,9.5,5.3,13,9.5c3.6,4.4,6.2,9.5,7.8,15c1.8,6.4,2.7,13,2.6,19.6v84.5H440.7z M388.5,237.6
	c4.7,0,9.3-0.5,13.9-1.6c4.1-1,8-2.6,11.7-4.6c3.6-2,7-4.3,10.1-7c3.1-2.7,6.2-5.6,9.3-8.7v-33.8c-10.7,0.2-21.3,1.1-31.9,2.8
	c-7.6,1.2-15,3.2-22,6.2c-5.8,2.6-10,5.7-12.8,9.3c-2.7,3.5-4.2,7.9-4.1,12.3c-0.1,3.9,0.6,7.7,2.2,11.3c2.5,6,7.6,10.5,13.9,12.3
	C381.9,237.1,385.2,237.6,388.5,237.6"
    />
    <path
      class="st2"
      d="M506.4,243.5V58.9h53.1c9.2-0.2,18.4,0.9,27.3,3.1c6.9,1.7,13.4,4.8,19.1,9.2c4.9,3.9,8.8,9,11.3,14.8
	c2.6,6.3,3.8,13,3.7,19.8c0,4.8-0.9,9.6-2.5,14.1c-1.7,4.6-4.2,8.8-7.4,12.5c-3.4,4-7.3,7.3-11.8,10c-5,3-10.4,5.1-16,6.4
	c14.5,2.2,25.7,7,33.5,14.5s11.7,17.3,11.7,29.6c0.1,7.3-1.3,14.5-4.2,21.1c-2.7,6.2-6.9,11.6-12.1,15.9c-5.8,4.6-12.5,8-19.6,10
	c-8.6,2.4-17.4,3.6-26.3,3.5L506.4,243.5z M519.7,145.2h40c8.5,0,15.8-1.1,21.8-3.3c5.5-1.8,10.5-4.8,14.9-8.6
	c3.7-3.4,6.6-7.5,8.5-12.1c1.8-4.4,2.7-9.2,2.7-14c0-12.4-3.9-21.9-11.8-28.2c-7.9-6.4-20-9.6-36.5-9.6h-39.7L519.7,145.2z
	 M519.7,155v77.8H566c16.3,0,28.5-3.5,36.8-10.5s12.4-16.9,12.4-29.6c0.1-5.4-1.1-10.8-3.3-15.7c-2.2-4.7-5.5-8.7-9.6-11.9
	c-4.6-3.5-9.8-6-15.4-7.5c-6.8-1.8-13.7-2.7-20.8-2.6H519.7z"
    />
    <path
      class="st2"
      d="M678.5,68.9c0,1.5-0.3,3-1,4.4c-0.6,1.3-1.5,2.5-2.5,3.6c-1,1-2.3,1.9-3.6,2.4c-2.8,1.2-6,1.2-8.9,0
	c-1.4-0.6-2.6-1.4-3.7-2.5c-1-1-1.9-2.2-2.5-3.5c-0.6-1.4-0.9-2.9-0.9-4.4c0-1.5,0.3-3.1,0.9-4.5c1.2-2.8,3.4-5,6.1-6.2
	c2.8-1.2,6-1.2,8.9,0c1.4,0.6,2.6,1.4,3.7,2.5c1.1,1.1,1.9,2.3,2.5,3.7C678.1,65.9,678.5,67.4,678.5,68.9 M673,243.5h-12.4V113.7
	H673L673,243.5z"
    />
    <path
      class="st2"
      d="M795.3,243.5c-2.2,0-3.4-1.1-3.7-3.4l-1.3-20.5c-5.4,7.5-12.3,13.9-20.2,18.7c-7.8,4.6-16.8,7-25.9,6.9
	c-15.9,0-28.4-5.5-37.3-16.6c-8.9-11-13.4-27.6-13.4-49.7c-0.1-9,1.2-18,3.7-26.6c2.3-7.8,6-15,11-21.4c4.8-6,10.9-10.9,17.8-14.3
	c7.6-3.6,15.9-5.4,24.2-5.2c8.8,0,16.4,1.6,22.8,4.9c6.6,3.4,12.3,8.3,16.7,14.3v-77h12.4v189.9H795.3z M747.7,235.1
	c8.3,0.1,16.4-2.2,23.4-6.7c7.4-4.9,13.8-11.2,18.7-18.5v-68.5c-5-7.4-10.6-12.6-16.7-15.7c-6.4-3.1-13.5-4.7-20.6-4.6
	c-6.9-0.2-13.8,1.3-20.1,4.2c-5.7,2.7-10.6,6.8-14.4,11.8c-4.1,5.5-7,11.7-8.8,18.3c-2,7.6-3,15.5-2.9,23.4
	c0,19.3,3.6,33.5,10.7,42.6C724.1,230.6,734.3,235.1,747.7,235.1"
    />
  </svg>
</div>
